import { render, staticRenderFns } from "./RegisteredProductsWarrantyRequest.vue?vue&type=template&id=2d7aeb09"
import script from "./RegisteredProductsWarrantyRequest.vue?vue&type=script&lang=js"
export * from "./RegisteredProductsWarrantyRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports